module.exports = __webpack_public_path__ + "img/santos.5c9d7ee9.png";